import apiService from 'src/enviroment';
import { loaderService } from 'src/services/loaderService';

const getEntries = async () => {
  loaderService.show();
  const response = await apiService.get(
    'insights/admin/entradas/sistema/?tipo=entradas_sistema',
  );
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const getUnidades = async () => {
  loaderService.show();
  const response = await apiService.get('segmentacion/unidadesnegocio/todos/');
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const putUnity = async (params) => {
  loaderService.show();
  const response = await apiService.put(
    'insights/admin/entradas/sistema/',
    params,
  );
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const updateEntries = async (params) => {
  loaderService.show();
  const response = await apiService.put(
    'insights/admin/entradas/sistema/',
    params,
  );
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

const archivarEntries = async (params) => {
  loaderService.show();
  const response = await apiService.put(
    'insights/admin/entradas/sistema/',
    params,
  );
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};
const reload = async () => {
  loaderService.show();
  try {
    const response = await apiService.post('insights/admin/entradas/sistema/');
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

export {
  getEntries, putUnity, getUnidades, updateEntries, archivarEntries, reload,
};
